import { AbstractEntity } from "../AbstractEntity";
import Signature from "../Signature";
import { getUtcNow } from "../../utils";
export default class Approval extends AbstractEntity {
    protocols;
    stage;
    role;
    approver;
    timestamp = getUtcNow();
    signature;
    constructor(approval = {}) {
        super();
        Object.assign(this, approval);
    }
}
//# sourceMappingURL=Approval.js.map